export default "__VITE_ASSET__CyCJEzei__"